var _polygon, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgJeuTablette = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.42 51.92",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: ".47 11.11 18.11 .66 35.92 13.71 26.19 33.15 4.98 33 .47 11.11",
    fill: "#ff7bae",
    opacity: 0.2,
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.28,5.65v11.49h-12.98v34.55h24.88v-7.62h20.52V5.65H28.28ZM38.63,44.07v6.08h-21.8v-31.47h21.8v25.39ZM33.12,17.14v-6.94h22.74v29.32h-15.68v-22.38h-7.06ZM59.15,42.53h-18.98v-1.47h17.22V8.66h-25.82v8.48h-1.76V7.19h29.33v35.34Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4,51.92H15.07V16.91h12.98V5.42h32.87v38.88h-20.52v7.62ZM15.53,51.46h24.42v-7.62h20.52V5.88h-31.95v11.49h-12.98v34.09ZM38.86,50.38h-22.26v-31.93h22.26v31.93ZM17.07,49.92h21.34v-31.01h-21.34v31.01ZM59.38,42.76h-19.44v-1.93h17.22V8.89h-25.36v8.48h-2.22V6.96h29.79v35.8ZM40.4,42.3h18.52V7.42h-28.87v9.49h1.3v-8.48h26.28v32.86h-17.22v1.01ZM56.08,39.75h-16.14v-22.38h-7.06v-7.4h23.19v29.78ZM40.4,39.29h15.22V10.43h-22.28v6.48h7.06v22.38Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.61,
    y: 16.03,
    width: 7.75,
    height: 1.54,
    transform: "translate(-1.65 27.59) rotate(-30.66)",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.47,19.75l-1.02-1.72,7.06-4.19,1.02,1.72-7.06,4.19ZM46.08,18.19l.55.93,6.27-3.72-.55-.93-6.27,3.72Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.75,
    y: 13.82,
    width: 4.08,
    height: 1.54,
    transform: "translate(-.75 26.43) rotate(-30.68)",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.35,16.61l-1.02-1.72,3.9-2.31,1.02,1.72-3.9,2.31ZM45.96,15.05l.55.93,3.11-1.85-.55-.93-3.11,1.85Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48.59,
    y: 18.61,
    width: 4.08,
    height: 1.54,
    transform: "translate(-2.8 28.55) rotate(-30.68)",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.19,21.4l-1.02-1.72,3.9-2.31,1.02,1.72-3.9,2.31ZM48.8,19.84l.55.93,3.11-1.85-.55-.93-3.11,1.85Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.58,20h-13.1v26.83h18.39v-26.83h-5.29ZM35.33,39.52v5.77h-15.31v-23.75h15.31v17.98Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1,47.06h-18.85v-27.29h18.85v27.29ZM18.71,46.6h17.93v-26.37h-17.93v26.37ZM35.56,45.52h-15.77v-24.21h15.77v24.21ZM20.25,45.06h14.85v-23.29h-14.85v23.29Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "28.28 36.4 21.99 40.13 22.78 41.46 28.28 38.2 29.44 37.51 28.66 36.18 28.28 36.4",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7,41.77l-1.02-1.72,7.06-4.19,1.02,1.72-7.06,4.19ZM22.31,40.21l.55.93,6.27-3.72-.55-.93-.18.11-6.09,3.61Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.98,
    y: 35.84,
    width: 4.08,
    height: 1.54,
    transform: "translate(-15.32 17.38) rotate(-30.68)",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.58,38.63l-1.02-1.72,3.9-2.31,1.02,1.72-3.9,2.31ZM22.19,37.07l.55.93,3.11-1.85-.55-.93-3.11,1.85Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "28.22 39.7 24.72 41.78 25.5 43.1 28.28 41.46 29.01 41.02 28.28 39.8 28.22 39.7",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.42,43.42l-1.02-1.72,3.9-2.31,1.02,1.72-3.9,2.31ZM25.03,41.86l.55.93,3.11-1.85-.55-.93-3.11,1.85Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJeuTablette);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Jeu tablette.bec87698d719fdd3840e306b71a0298d.svg";